module.exports = __webpack_public_path__ + "static/media/SprintBurndown.a9afa143.png";